import { Theme } from '@mui/material/styles'

const muiMenuItem = (theme: Theme) => {
  return {
    styleOverrides: {
      root: {
        //todo: why is this here?
        '@media(min-width:600px)': {
          minHeight: '3rem'
        },
        '&.Mui-selected': {
          background: theme.palette.success.light,
          '&:hover': {
            background: theme.palette.success.light
          }
        }
      },
      divider: {
        root: {
          margin: 0
        }
      }
    }
  }
}

export default muiMenuItem
